import { DOMUtil } from "@mcleod/core";
import { Tab } from "./Tab";

export class TabHeadingLabelSizer {
    private tab: Tab;

    constructor(tab: Tab) {
        this.tab = tab;
        this.tab.heading.addContentsChangedListener(this.setLabelWidth);
        this.tab.heading.addResizeListener(this.setLabelWidth);
    }

    setLabelWidth = () => {
        const otherElements: Element[] = this.tab.heading.components
            .filter(component => component !== this.tab.headingLabel)
            .map(component => component._element);
        let widthAvailableForLabel: number;
        this.tab.heading.doWhileDimensionsComputed(() => {
            widthAvailableForLabel = DOMUtil.getAvailableWidth(this.tab.heading._element, otherElements);
        });
        // Apply the calculated width to the label
        if (widthAvailableForLabel > 0) {
            this.tab.headingLabel.style.maxWidth = `${widthAvailableForLabel}px`;
        }
        this.setHeadingLabelTooltip();
    }

    /**
     * If the tab's heading label is too long for its width, set the tab's tooltip to the full label text.
     * Otherwise clear the tooltip.
     */
    private setHeadingLabelTooltip() {
        if (DOMUtil.isElementOverflowingX(this.tab.headingLabel._element)) {
            if (this.tab.tooltip == null) {
                this.tab.tooltip = this.tab.caption;
            }
        } else if (this.tab.tooltip === this.tab.caption) {
            this.tab.tooltip = null;
        }
    }
}
